// User Type Constants
export const USER_TYPES = {
  OWNER: 'OWNER',
  EMPLOYEE: 'EMPLOYEE',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

// Module Permission Mapping
export const PERMISSIONS = {
  SETTINGS: {
    VIEW: 'settings.view',
    CREATE: 'settings.create',
    UPDATE: 'settings.update',
    DELETE: 'settings.delete',
  },
  CRM_CONFIG: {
    VIEW: 'crm_config.view',
    CREATE: 'crm_config.create',
    UPDATE: 'crm_config.update',
    DELETE: 'crm_config.delete',
    MANAGE: 'crm_config.manage',
  },
  /** Granular CRM Configuration tab permissions (preferred over CRM_CONFIG) */
  AUTO_ASSIGNMENT: {
    VIEW: 'auto_assignment.view',
    CREATE: 'auto_assignment.create',
    UPDATE: 'auto_assignment.update',
    DELETE: 'auto_assignment.delete',
  },
  PROFILE: {
    VIEW: 'profile.view',
    EDIT: 'profile.edit',
  },
  ROLES: {
    VIEW: 'roles.view',
    CREATE: 'roles.create',
    UPDATE: 'roles.update',
    DELETE: 'roles.delete',
  },
  MEMBERS: {
    VIEW: 'employees.view',
    CREATE: 'employees.create',
    UPDATE: 'employees.update',
    DELETE: 'employees.delete',
  },
  LEADS: {
    VIEW: 'lead.view',
    CREATE: 'lead.create',
    UPDATE: 'lead.update',
    DELETE: 'lead.delete',
  },
  LEADS_ALL: {
    VIEW: 'lead.view_all',
    CREATE: 'lead.create_all',
    UPDATE: 'lead.update_all',
    DELETE: 'lead.delete_all',
  },
  PIPELINES: {
    VIEW: 'pipelines.view',
    CREATE: 'pipelines.create',
    UPDATE: 'pipelines.update',
    DELETE: 'pipelines.delete',
  },
  SEGMENTS: {
    VIEW: 'segments.view',
    CREATE: 'segments.create',
    UPDATE: 'segments.update',
    DELETE: 'segments.delete',
  },
  TAGS: {
    VIEW: 'tags.view',
    CREATE: 'tags.create',
    UPDATE: 'tags.update',
    DELETE: 'tags.delete',
  },
  CUSTOM_FIELDS: {
    VIEW: 'custom_fields.view',
    CREATE: 'custom_fields.create',
    UPDATE: 'custom_fields.update',
    DELETE: 'custom_fields.delete',
  },
  FEEDBACK: {
    VIEW: 'feedback.view',
    CREATE: 'feedback.create',
    UPDATE: 'feedback.update',
    DELETE: 'feedback.delete',
  },
  LEAD_MANAGEMENT: {
    VIEW: 'lead_management.view',
    CREATE: 'lead_management.create',
    UPDATE: 'lead_management.update',
    DELETE: 'lead_management.delete',
  },
  WA_TEMPLATES: {
    VIEW: 'wa_templates.view',
    CREATE: 'wa_templates.create',
    UPDATE: 'wa_templates.update',
    DELETE: 'wa_templates.delete',
  },
  WA_FLOWS: {
    VIEW: 'wa_flows.view',
    CREATE: 'wa_flows.create',
    UPDATE: 'wa_flows.update',
    DELETE: 'wa_flows.delete',
  },
  WA_CAMPAIGNS: {
    VIEW: 'wa_campaigns.view',
    CREATE: 'wa_campaigns.create',
    UPDATE: 'wa_campaigns.update',
    DELETE: 'wa_campaigns.delete',
  },
  WA_CHATS: {
    VIEW: 'wa_chats.view',
    CREATE: 'wa_chats.create',
    UPDATE: 'wa_chats.update',
    DELETE: 'wa_chats.delete',
  },
  WA_CUSTOMERS: {
    VIEW: 'wa_customers.view',
    CREATE: 'wa_customers.create',
    UPDATE: 'wa_customers.update',
    DELETE: 'wa_customers.delete',
  },
  CONTACTS: {
    VIEW: 'contact.view',
    CREATE: 'contact.create',
    UPDATE: 'contact.update',
    DELETE: 'contact.delete',
  },
  DASHBOARD: {
    VIEW: 'dashboard.view',
  },
  DIGITAL_CARD: {
    VIEW: 'digital_card.view',
  },
  INTEGRATION: {
    VIEW: 'integration.view',
  },
  APPOINTMENTS: {
    VIEW: 'appointment.view',
    CREATE: 'appointment.create',
    UPDATE: 'appointment.update',
    DELETE: 'appointment.delete',
  },
  QUOTATIONS: {
    VIEW: 'quotation.view',
    CREATE: 'quotation.create',
    UPDATE: 'quotation.update',
    DELETE: 'quotation.delete',
  },
  REMINDERS: {
    VIEW: 'reminder.view',
    CREATE: 'reminder.create',
    UPDATE: 'reminder.update',
    DELETE: 'reminder.delete',
  },
};
